// An unsubscribe page carries its link's token in its path, and whoever holds
// the token can turn that customer's newsletters or reminders off and on.
// Every analytics destination ships the page URL with each event, so nothing on
// these paths may reach one. Imported by lib/posthog, so it imports nothing.
const UNSUBSCRIBE_PAGE_PREFIXES = ['/unsubscribe/', '/reminders-off/'];

// Decoded and lowercased, so a hand-escaped or differently cased address that
// still reaches a page cannot slip past the gate.
export const isUnsubscribePagePath = (pathname: string): boolean => {
  let path = pathname;
  try {
    path = decodeURIComponent(pathname);
  } catch {
    // A malformed escape is checked as it stands.
  }
  const lowered = path.toLowerCase();
  return UNSUBSCRIBE_PAGE_PREFIXES.some((prefix) => lowered.startsWith(prefix));
};
